// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';

// Pages
import Home from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Services';
import Products from './Pages/Products';
import Projects from './Pages/Projects';
import Contact from './Pages/Contact';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

function Navbar() {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <span className="logo-text">ESSELTECH</span>
          <span className="logo-subtext">Engineering Pvt Ltd</span>
        </Link>

        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/about" className="nav-link">About Us</Link>
          <Link to="/services" className="nav-link">Services</Link>
          <Link to="/products" className="nav-link">Products</Link>
          <Link to="/projects" className="nav-link">Projects</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
        </div>

        <button className="nav-toggle" onClick={() => setIsOpen(!isOpen)}>
          ☰
        </button>
      </div>
    </nav>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Esseltech Engineering</h3>
          <p>Advanced Fire Protection and Engineering Solutions</p>
          <p style={{lineHeight: '1.5'}}>📍 157 A 1/1 ,<br />Dharmapala Mawatha ,<br />Colombo 07 , 00700,<br />Sri Lanka</p>
          <p>📞 +94 77 655 6000 (Hot Line)</p>
          <p>📞 +94 71 655 6000 (Whatsapp Only)</p>
          <p>📞 +94 113 495 900</p>
          <p>✉️ info@esseltech.lk</p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <Link to="/services">Services</Link>
          <Link to="/products">Products</Link>
          <Link to="/projects">Projects</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-section">
          <h3>Services</h3>
          <Link to="/services">Fire Detection</Link>
          <Link to="/services">Fire Protection</Link>
          <Link to="/services">Electrical Systems</Link>
          <Link to="/services">Security Systems</Link>
        </div>

        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-links">
            <a href="https://linkedin.com">LinkedIn</a>
            <a href="https://facebook.com">Facebook</a>
            <a href="https://twitter.com">Twitter</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2024 Esseltech Engineering Pvt Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default App;
